// filepath: /components/shipments-products/InvoicesOrdersModalContent.tsx
import React from "react";
import { Text, Divider, Label } from "@nike/eds";
import { InvoicesOrdersTable } from "../invoices-orders-table/InvoicesOrdersTable";
import { ShipmentProduct, CommercialDocument } from "../../graphql/graphql";
import type { TableRef } from "../base-table";

export const InvoicesOrdersModalContent = ({
  tableRef,
  shipmentProduct,
}: {
  tableRef: React.Ref<TableRef>;
  shipmentProduct: ShipmentProduct | null;
}) => {
  const baseCommercialDocument = shipmentProduct?.commercialDocuments?.find(
    (doc) => doc?.useAsBaseValue === true
  );
  const value =
    baseCommercialDocument?.declarationAmount !== undefined
      ? (baseCommercialDocument.currency &&
          typeof baseCommercialDocument.currency === "string" &&
          baseCommercialDocument.currency.trim().length === 3
          ? new Intl.NumberFormat("en-US", { style: "currency", currency: baseCommercialDocument.currency }).format(baseCommercialDocument.declarationAmount)
          : baseCommercialDocument.declarationAmount.toLocaleString("en-US"))
      : "N/A";

  return (
    <div>
      <Text className="eds-spacing--mb-16" font="title-5" as="h3">Product Information</Text>
      <div className="eds-grid eds-grid--m-cols-2 eds-spacing--mb-24">
        <div>
          <Label font={"body-3"}>Product Code</Label>
          <Text font={"body-1"}>{shipmentProduct?.productCode ?? "N/A"}</Text>
        </div>
        <div>
          <Label font={"body-3"}>Quantity</Label>
          <Text font={"body-1"}>{shipmentProduct?.quantity ?? "N/A"}</Text>
        </div>
        <div>
          <Label font={"body-3"}>Declaration Price</Label>
          <Text font={"body-1"}>{value}</Text>
        </div>
      </div>
      <Divider className="eds-spacing--mb-24" />
      <Text className="eds-spacing--mb-4" font="title-5" as="h3">Related Invoices and Orders</Text>
      <InvoicesOrdersTable
        tableRef={tableRef}
        data={
          shipmentProduct?.commercialDocuments
            ?.filter((doc): doc is CommercialDocument => doc !== null)
            ?.sort((a, b) => (b.declarationAmount ?? 0) - (a.declarationAmount ?? 0))
          || []
        }
      />
    </div>
  );
};